// For now, this file has to be separated from the other utils because
// Jest is complaining when importing src/util file

const roundNumberWithNDecimals = (number, n, roundUp = false) => {
  const formatted = number.toFixed(n)
  if (number !== 0 && roundUp && formatted === `0.${'0'.repeat(n)}`) {
    // handle case 0.00001 should be 0.01 if n = 2, not 0
    return parseFloat(`0.${'0'.repeat(n - 1)}1`)
  }
  return parseFloat(formatted) // remove trailing 0s
}

export default roundNumberWithNDecimals
